import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient, BankDetails, DeliverService, DeliverServicesClient, NServices, ServiceClient, ServiceProvider } from "src/app/web-api-client";

@Component({
  selector: 'app-deliverService-creation',
  templateUrl: './deliverService-creation.component.html',
  styleUrls: ['./deliverService-creation.component.scss']
})
export class DeliverServiceCreationComponent implements OnInit {

  public isLoaded = false;
  public serviceProviderId: number;
  public selectedBankAccount: BankDetails;
  public services: NServices[];
  public onClose = new Subject();

  Form: FormGroup;

  // ServiceTermType options for dropdown
  serviceTermTypes = [
    { value: 0, label: 'Неизвестен (Unknown)' },
    { value: 1, label: 'Експресна услуга (Express)' },
    { value: 2, label: 'Бърза услуга (Fast)' },
    { value: 3, label: 'Обикновена услуга (Standard)' }
  ];

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: DeliverServicesClient, public serviceClient: ServiceClient) { }

  ngOnInit(): void {

    this.serviceClient.getList().subscribe(services => {

      this.services = services;
      this.initializeForm();
      this.isLoaded = true;

    })

  }

  initializeForm() {
    this.Form = this.fb.group({
       title: ['', Validators.required],
      deliverTaxe: ['', Validators.required],
      service: ['', Validators.required],
      isActive: [null, Validators.required],
      staticTax: [false],
      serviceTermTypeId: [0],
      sample: ['']
    });

    // Set up two-way binding between deliverTaxe and staticTax
    this.setupTaxBindings();
  }

  private setupTaxBindings() {
    // When deliverTaxe changes, update staticTax
    this.Form.get('deliverTaxe')?.valueChanges.subscribe(value => {
      const taxAmount = parseFloat(value);
      if (!isNaN(taxAmount) && taxAmount > 0) {
        this.Form.get('staticTax')?.setValue(true, { emitEvent: false });
      }
    });

    // When staticTax is unchecked, set deliverTaxe to 0
    this.Form.get('staticTax')?.valueChanges.subscribe(value => {
      if (value === false) {
        this.Form.get('deliverTaxe')?.setValue(0, { emitEvent: false });
      }
    });
  }

  onBankAccountSelected(bankAccount: BankDetails) {
    this.selectedBankAccount= bankAccount;
  }

  onSubmit() {
    if (this.Form.valid && this.selectedBankAccount) {

      let service = new DeliverService();

      service.idDeliversService = 0;
      service.title = this.Form.value.title;
      service.deliverTaxe = this.Form.value.deliverTaxe;
      service.idBankDetails = this.selectedBankAccount.idBankDetails;
      service.isActive = this.Form.value.isActive;
      service.idService = this.Form.value.service;
      service.idServiceProvider = this.serviceProviderId;
      service.staticTax = this.Form.value.staticTax;
      service.serviceTermTypeId = +this.Form.value.serviceTermTypeId;
      service.sample = this.Form.value.sample || null;
      //service.serviceProvider = new ServiceProvider({serviceProviderName:'test',serviceProviderEIK:'test'});
      //service.service = new NServices({serviceName:'test',uri:'test',serviceTemplate:'test',serviceRequestTemplate:undefined});

      this.client.create(service).subscribe((user) => {

        this.onClose.next('');
        this.activeModal.close();
      });
    }
  }

}
